// Components==============
import Modal from 'components/UI/Modal/Modal';
import { useReduxAction } from 'hooks/useReduxAction';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import Button from 'components/UI/Button/Button';
import './ExportModal.module.scss';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import exportProject from 'actions/export/show';
import Spinner from 'components/UI/Spinner/Spinner';
// =========================

export default function ExportModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { project } = useContext(ProjectDetailsContext);

  const translate = useTranslate();
  const dispatch = useReduxAction();

  const [shapeExport, setShapeExport] = useState(1);
  const [sizeExport, setSizeExport] = useState('');
  const [loading, setLoading] = useState(false);

  const sizeNames: string[] = [
    translate('project.export-process.export-choose-size1') as string,
    translate('project.export-process.export-choose-size2') as string,
    translate('project.export-process.export-choose-size3') as string,
  ];

  function ExportProcess() {
    setLoading(true);
    let exportSize = 0;
    if (
      sizeExport === translate('project.export-process.export-choose-size1')
    ) {
      exportSize = 0;
    } else if (
      sizeExport === translate('project.export-process.export-choose-size2')
    ) {
      exportSize = 1;
    } else if (
      sizeExport === translate('project.export-process.export-choose-size3')
    ) {
      exportSize = 2;
    }

    console.log(
      `id: ${project?.id} size: ${exportSize} output: ${shapeExport}`
    );

    dispatch(
      exportProject({
        id: project?.id,
        size: exportSize,
        output: shapeExport,
      })
    )
      .then((response) => {
        setLoading(false);
        console.log(response.filename);
        window.open(`/api/download/${response.filename}`);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="content">
        <>
          <h1 styleName="title">
            {translate('project.export-process.export-process')}
          </h1>

          <>
            <h2>{translate('project.export-process.export-choose-type')}</h2>
            <p styleName="description">
              {translate('project.export-process.export-choose-type-text')}
            </p>
            <div styleName="buttons">
              <button
                color="white"
                type="button"
                onClick={() => {
                  setShapeExport(1);
                }}
                styleName={shapeExport === 1 ? 'selected' : 'unselected'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="216"
                  height="120"
                  viewBox="0 0 216 120"
                >
                  <g
                    id="Shape1"
                    data-name="Shape1"
                    transform="translate(-38 -138)"
                  >
                    <rect
                      id="Shape1-bg"
                      data-name="Shape1-bg"
                      width="216"
                      height="120"
                      rx="7"
                      transform="translate(38 138)"
                      fill="#fff"
                    />
                    <g
                      id="Shape1-shape"
                      data-name="Shape1-shape"
                      transform="translate(43.637 174)"
                    >
                      <path
                        id="Path_2933"
                        data-name="Path 2933"
                        d="M24.99,0,0,18.157,9.545,47.534H40.434l9.545-29.377Z"
                        transform="translate(0 0)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2934"
                        data-name="Path 2934"
                        d="M87.4,35.826l6.714,20.665H115.84l6.715-20.665L104.976,23.055Z"
                        transform="translate(-33.958 -8.958)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2935"
                        data-name="Path 2935"
                        d="M150.553,35.826l6.714,20.665H179l6.714-20.665L168.132,23.055Z"
                        transform="translate(-58.497 -8.958)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2936"
                        data-name="Path 2936"
                        d="M213.709,35.826l6.715,20.665h21.728l6.715-20.665L231.288,23.055Z"
                        transform="translate(-83.036 -8.958)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2937"
                        data-name="Path 2937"
                        d="M276.865,35.826l6.714,20.665h21.729l6.714-20.665L294.444,23.055Z"
                        transform="translate(-107.575 -8.958)"
                        fill="#ececec"
                      />
                    </g>
                  </g>
                </svg>
                <p>
                  {translate('project.export-process.export-choose-shape1')}
                </p>
              </button>
              <button
                color="white"
                type="button"
                onClick={() => {
                  setShapeExport(2);
                }}
                styleName={shapeExport === 2 ? 'selected' : 'unselected'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="216"
                  height="120"
                  viewBox="0 0 216 120"
                >
                  <g
                    id="Shape2"
                    data-name="Shape2"
                    transform="translate(-266 -138)"
                  >
                    <rect
                      id="Shape2-bg"
                      data-name="Shape2-bg"
                      width="216"
                      height="120"
                      rx="7"
                      transform="translate(266 138)"
                      fill="#fff"
                    />
                    <g
                      id="Shape2-shape"
                      data-name="Shape2-shape"
                      transform="translate(285.688 170)"
                    >
                      <path
                        id="Path_2938"
                        data-name="Path 2938"
                        d="M24.99,0,0,18.156,9.545,47.534H40.434l9.545-29.377Z"
                        transform="translate(0 0)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2939"
                        data-name="Path 2939"
                        d="M75.686,57.1,93.209,69.951l17.634-12.7-6.624-20.694L82.49,36.467Z"
                        transform="translate(-29.407 -14.169)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2940"
                        data-name="Path 2940"
                        d="M182.832,57.148,200.355,70,217.99,57.3l-6.624-20.694-21.728-.095Z"
                        transform="translate(-71.039 -14.187)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2941"
                        data-name="Path 2941"
                        d="M147.015,15.734,129.437,28.506l6.714,20.665H157.88l6.714-20.665Z"
                        transform="translate(-50.292 -6.113)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2942"
                        data-name="Path 2942"
                        d="M234.633,28.506l6.714,20.665h21.728l6.715-20.665L252.211,15.734Z"
                        transform="translate(-91.166 -6.114)"
                        fill="#ececec"
                      />
                    </g>
                  </g>
                </svg>
                <p>
                  {translate('project.export-process.export-choose-shape2')}
                </p>
              </button>
              <button
                color="white"
                type="button"
                onClick={() => {
                  setShapeExport(3);
                }}
                styleName={shapeExport === 3 ? 'selected' : 'unselected'}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="216"
                  height="120"
                  viewBox="0 0 216 120"
                >
                  <g
                    id="Shape3"
                    data-name="Shape3"
                    transform="translate(-497 -138)"
                  >
                    <rect
                      id="Shape3-bg"
                      data-name="Shape3-bg"
                      width="216"
                      height="120"
                      rx="7"
                      transform="translate(497 138)"
                      fill="#fff"
                    />
                    <g
                      id="Shape3-shape"
                      data-name="Shape3-shape"
                      transform="translate(522.184 160)"
                    >
                      <path
                        id="Path_2943"
                        data-name="Path 2943"
                        d="M6.411,25.28,0,55.5,26.757,70.931,49.7,50.253,37.129,22.04Z"
                        transform="translate(0 -8.563)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2944"
                        data-name="Path 2944"
                        d="M85.231,0l-16.2,14.475L77.785,34.36,99.4,32.174l4.6-21.235Z"
                        transform="translate(-26.82 0)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2945"
                        data-name="Path 2945"
                        d="M176.139,52.236,159.934,66.711,168.693,86.6l21.619-2.185,4.6-21.236Z"
                        transform="translate(-62.142 -20.296)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2946"
                        data-name="Path 2946"
                        d="M129.775,17.907l-4.509,21.255L144.087,50.02l16.142-14.545-8.845-19.847Z"
                        transform="translate(-48.672 -6.072)"
                        fill="#ececec"
                      />
                      <path
                        id="Path_2947"
                        data-name="Path 2947"
                        d="M219.754,71.171l-4.509,21.255,18.822,10.858,16.142-14.546-8.846-19.847Z"
                        transform="translate(-83.633 -26.768)"
                        fill="#ececec"
                      />
                    </g>
                  </g>
                </svg>
                <p>
                  {translate('project.export-process.export-choose-shape3')}
                </p>
              </button>
            </div>
          </>
          <div styleName="bar" />
          <>
            <h2>{translate('project.export-process.export-choose-size')}</h2>
            <p styleName="description">
              {translate('project.export-process.export-choose-size-text')}
            </p>
            <div styleName="dropdown">
              <Dropdown
                selectedItem={sizeExport}
                setSelectedItem={setSizeExport}
                initialOptions={sizeNames}
                initialText={translate(
                  'project.export-process.export-choose-size1'
                )}
              />
            </div>
          </>
          <>
            <div styleName="buttons-submit">
              <Button color="grey" onClick={() => setModalIsOpen(false)}>
                {translate('project.export-process.export-cancel')}
              </Button>
              <Button color="blue" onClick={ExportProcess}>
                {translate('project.export-process.export-button')}
                <div styleName="loader-wrapper">
                  <Spinner loading={loading} />
                </div>
              </Button>
            </div>
            <></>
          </>
        </>
      </div>
    </Modal>
  );
}
